.tfxm1l0 {
  color: var(--_1qu8za24);
}